var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3831_12156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36133 7.43799L5.33594 3.37207C5.55615 3.15185 5.77637 3.05518 6.03955 3.05518C6.30811 3.05518 6.53369 3.15723 6.74316 3.37207L10.7178 7.43799C10.8789 7.59912 10.9595 7.79248 10.9595 8.02881C10.9595 8.50684 10.5781 8.89355 10.1055 8.89355C9.87451 8.89355 9.64893 8.80225 9.47705 8.61963L6.04492 5.08008L2.60742 8.61963C2.43018 8.79687 2.20996 8.89355 1.97363 8.89355C1.50098 8.89355 1.11963 8.50684 1.11963 8.02881C1.11963 7.79785 1.2002 7.59912 1.36133 7.43799Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3831_12156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronTop);
export default __webpack_public_path__ + "static/media/chevron-top.9c851d918f1a3f6d109e3331f8572405.svg";
export { ForwardRef as ReactComponent };